import { Action } from '@ngrx/store';
import { LoadDataRequest, LoadDataRequestAtlas, SortInfo } from '../../global/interfaces';
import { LoadDocumentsResponse, DocumentFileDownloadRequest, DocumentZipFileDownloadRequest } from '../documents/documents.models';
import { PaginationComponent, PaginationInfo } from 'atlas-pagination';
export enum ActionTypes {
  LOAD_STATEMENT_TYPES = '[Statements] Load Statement Types Action',
  LOAD_STATEMENT_TYPES_SUCCESS = '[Statements] Load Statement Types Success Action',
  LOAD_STATEMENT_TYPES_FAILED = '[Statements] Load Statement Types Failed Action',

  LOAD_STATEMENTS = '[Statements] Load Statements Action',
  LOAD_STATEMENTS_SUCCESS = '[Statements] Load Statements Success Action',
  LOAD_STATEMENTS_FAILED = '[Statements] Load Statements Failed Action',

  LOAD_MOBILE_STATEMENTS = '[Statements] Load Mobile Statements Action',
  LOAD_MOBILE_STATEMENTS_SUCCESS = '[Statements] Load Mobile Statements Success Action',
  LOAD_MOBILE_STATEMENTS_FAILED = '[Statements] Load Mobile Statements Failed Action',

  SET_STATEMENTS_MOBILE_PAGINATION = '[Statements] Set Statements Mobile Pagination Action',

  SET_STATEMENTS_PAGINATION = '[Statements] Set Statements Pagination Action',

  SET_STATEMENTS_SORT = '[Statements] Set Statements Sort Action',

  SET_STATEMENTS_TYPE = '[Statements] Set Statements Type Filter Action',
  SET_STATEMENTS_FROM = '[Statements] Set Statements From Filter Action',
  SET_STATEMENTS_TO = '[Statements] Set Statements To Filter Action',

  STATEMENTS_FILE_DOWNLOAD = '[Statements] Statements PDF Download Action',
  RESET_STATEMENTS = '[Statements] Reset Statements Data Action',
  RESET_MOBILE_STATEMENTS = '[Statements] Reset Mobile Statements Data Action',
  DOWNLOAD_STATEMENTS_ZIP = '[Statements] Download Statements Zip Action'
}

/**
 * Load Statement Sub-Types
 */
export class LoadStatementTypesAction implements Action {
  public readonly type = ActionTypes.LOAD_STATEMENT_TYPES;

  public constructor(public payload: any) {
  }
}

export class LoadStatementTypesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_STATEMENT_TYPES_SUCCESS;

  public constructor(public payload: string[]) {
  }
}

export class LoadStatementTypesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_STATEMENT_TYPES_FAILED;

  public constructor(public payload: any) {
  }
}

/**
 * Load data for desktop
 */
export class LoadStatementsAction implements Action {
  readonly type = ActionTypes.LOAD_STATEMENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadStatementsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_STATEMENTS_SUCCESS;

  public constructor(public payload: LoadDocumentsResponse) {
  }
}

export class LoadStatementsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_STATEMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

export class DownloadStatementsZipAction implements Action {
  readonly type = ActionTypes.DOWNLOAD_STATEMENTS_ZIP;
  constructor(public payload: DocumentZipFileDownloadRequest) { }
}

/**
 * Load data for mobile
 * Appends instead of overriding
 */
export class LoadMobileStatementsAction implements Action {
  readonly type = ActionTypes.LOAD_MOBILE_STATEMENTS;

  public constructor(public payload: LoadDataRequestAtlas) {
  }
}

export class LoadMobileStatementsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_MOBILE_STATEMENTS_SUCCESS;

  public constructor(public payload: LoadDocumentsResponse) {
  }
}

export class LoadMobileStatementsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_MOBILE_STATEMENTS_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetStatementsMobilePaginationAction implements Action {
  public readonly type = ActionTypes.SET_STATEMENTS_MOBILE_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

/**
 * Filters
 */
export class SetStatementsTypeFilterAction implements Action {
  readonly type = ActionTypes.SET_STATEMENTS_TYPE;

  public constructor(public payload: string[]) {
  }
}

export class SetStatementsFromFilterAction implements Action {
  readonly type = ActionTypes.SET_STATEMENTS_FROM;

  public constructor(public payload: string) {
  }
}

export class SetStatementsToFilterAction implements Action {
  readonly type = ActionTypes.SET_STATEMENTS_TO;

  public constructor(public payload: string) {
  }
}

export class SetStatementsSortAction implements Action {
  readonly type = ActionTypes.SET_STATEMENTS_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class SetStatementsPaginationAction implements Action {
  readonly type = ActionTypes.SET_STATEMENTS_PAGINATION;

  public constructor(public payload: PaginationInfo) {
  }
}

export class StatementsFileDownloadAction implements Action {
  readonly type = ActionTypes.STATEMENTS_FILE_DOWNLOAD;

  public constructor(public payload: DocumentFileDownloadRequest) {
  }
}

export class ResetStatementsAction implements Action {
  readonly type = ActionTypes.RESET_STATEMENTS;
}

export class ResetMobileStatementsAction implements Action {
  readonly type = ActionTypes.RESET_MOBILE_STATEMENTS;
}

export type Actions =
  LoadStatementTypesAction |
  LoadStatementTypesSuccessAction |
  LoadStatementTypesFailedAction |
  LoadStatementsAction |
  LoadStatementsSuccessAction |
  LoadStatementsFailedAction |
  LoadMobileStatementsAction |
  LoadMobileStatementsSuccessAction |
  LoadMobileStatementsFailedAction |
  SetStatementsMobilePaginationAction |
  SetStatementsTypeFilterAction |
  SetStatementsFromFilterAction |
  SetStatementsToFilterAction |
  SetStatementsSortAction |
  SetStatementsPaginationAction |
  StatementsFileDownloadAction |
  ResetStatementsAction |
  ResetMobileStatementsAction |
  DownloadStatementsZipAction;
